import { TextFieldProps } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import { Dayjs } from 'dayjs';
import { PDatePickerProps } from '@/components/atoms/DatePicker/types';
import { lockedTextFieldSx } from '@/components/atoms/TextField/lockedSx';
import { mergeSx } from '@/utils/cssStyles';

/**
 * `PDatePicker` is the design system atom for a single-date field (wraps MUI-X
 * `DesktopDatePicker`).
 *
 * Adds a third `state`: alongside `enabled`/`disabled`, `locked` renders the text field with a
 * readable filled treatment (instead of MUI's dimmed disabled look) for a date the user needs to
 * read but can't change right now.
 */
export const PDatePicker = ({ state = 'enabled', slotProps, ...other }: PDatePickerProps) => {
  const isDisabled = state !== 'enabled';
  const textFieldSlotProps = slotProps?.textField as TextFieldProps | undefined;

  return (
    <DesktopDatePicker<Dayjs>
      disabled={isDisabled}
      slotProps={{
        ...slotProps,
        textField: {
          ...textFieldSlotProps,
          disabled: isDisabled,
          sx: mergeSx(state === 'locked' ? lockedTextFieldSx : undefined, textFieldSlotProps?.sx),
        },
      }}
      {...other}
    />
  );
};
